<template>
  <v-dialog v-model="dialogState" max-width="800" persistent>
    <v-card>
      <v-toolbar
        color="primary"
        flat
        short
      >
        <v-toolbar-title>Gebruiker</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="hideDialog" icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form
          autocomplete="off"
        >
          <v-container class="mt-5">
            <v-row>
              <v-col cols="6" sm="6">
                <v-text-field
                  v-model="item.username"
                  label="Gebruikersnaam"
                  :error-messages="errors.username"
                  autocomplete="off"
                ></v-text-field>
                <v-text-field
                  v-model="item.password"
                  type="password"
                  label="Wachtwoord"
                  :error-messages="errors.password"
                  autocomplete="off"
                ></v-text-field>
                <v-text-field
                  v-model="item.first_name"
                  label="Voornaam"
                  :error-messages="errors.first_name"
                  autocomplete="off"
                ></v-text-field>
                <v-text-field
                  v-model="item.last_name"
                  label="Achternaam"
                  :error-messages="errors.last_name"
                  autocomplete="off"
                ></v-text-field>
                <v-text-field
                  v-model="item.email"
                  label="Email"
                  :error-messages="errors.email"
                ></v-text-field>
                <v-text-field
                  v-model="item.phone_number"
                  label="Telefoon"
                  :error-messages="errors.phone_number"
                ></v-text-field>


              </v-col>
              <v-col cols="6" sm="6">
                <v-text-field
                  v-model="item.company_name"
                  label="Bedrijfsnaam"
                  :error-messages="errors.company_name"
                  autocomplete="off"
                ></v-text-field>
                <v-text-field
                  v-if="isCompany"
                  v-model="item.company_address_street"
                  label="Straat"
                  :error-messages="errors.company_address_street"
                  autocomplete="off"
                ></v-text-field>
                <v-text-field
                  v-if="isCompany"
                  v-model="item.company_address_house_number"
                  label="Huisnummer"
                  :error-messages="errors.company_address_house_number"
                  autocomplete="off"
                ></v-text-field>
                <v-text-field
                  v-if="isCompany"
                  v-model="item.company_address_postcode"
                  label="Postcode"
                  :error-messages="errors.company_address_postcode"
                  autocomplete="off"
                ></v-text-field>
                <v-text-field
                  v-if="isCompany"
                  v-model="item.company_address_city"
                  label="Plaats"
                  :error-messages="errors.company_address_city"
                ></v-text-field>

                <v-switch
                  v-model="item.is_admin"
                  label="Beheerder"
                  :false-value="0"
                  :true-value="1"
                  :error-messages="errors.is_admin"
                ></v-switch>

                <v-switch
                  v-model="item.status"
                  label="Actief"
                  :false-value="0"
                  :true-value="10"
                  :error-messages="errors.status"
                ></v-switch>

              </v-col>

            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="item.mail_subject"
                  label="E-mail onderwerp"
                  :error-messages="errors.mail_subject"
                ></v-text-field>
                <v-textarea
                  v-model="item.mail_body"
                  label="E-mail bericht"
                  :error-messages="errors.mail_body"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions class="px-10 pb-10">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="saveItem">{{ isNewItem ? 'Toevoegen' : 'Opslaan' }}</v-btn>
        <v-btn color="default" @click="hideDialog">Annuleren</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import ApiService from '@/services/api.service'

export default {
  data () {
    return {
      dialogState: false,

      item: {},
      errors: {},
    }
  },
  computed: {
    isCompany() {
      return this.item.company_name && this.item.company_name.length
    },
    isNewItem() {
      return !this.item.id
    },
  },
  watch: {
    item: {
      deep: true,
      handler(val){
        console.log(val)
      },
    }
  },
  methods: {
    showDialog(id = null) {
      if (id !== null) {
        this.fetchItem(id)
      }
      this.dialogState = true
    },
    hideDialog() {
      this.dialogState = false
      this.item = {}
      this.errors = {}
    },
    fetchItem(id) {
      this.$store.dispatch('session/showLoader')
      this.errors = {}
      ApiService.view(`/users/${id}`, {
      }).then(item => {
        this.item = item
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
    updateItem() {
      this.errors = {}
      this.$store.dispatch('session/showLoader')
      ApiService.update(`/users/${this.item.id}`, {
        ...this.item,
      }).then(item => {
        this.$emit('update', item)
        this.hideDialog()
      }).catch(errors => {
        this.errors = errors
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
    createItem() {
      this.errors = {}
      this.$store.dispatch('session/showLoader')
      ApiService.create('/users', {
        ...this.item,
      }).then(item => {
        this.item = item
        this.$emit('update', item)
        this.hideDialog()
      }).catch(errors => {
        this.errors = errors
      }).finally(() => {
        this.$store.dispatch('session/hideLoader')
      })
    },
    saveItem() {
      if (this.isNewItem) {
        this.createItem()
      } else {
        this.updateItem()
      }
    },
  },
}
</script>
